import { css, cx } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const footerStyles = css`
  font-size: 0.875rem;
  padding: 0.875rem 0.625rem;
`;
const titleAndPriceWrapperStyles = css`
  align-items: center;
  display: flex;
`;
const titleStyles = css`
  display: flex;
  flex: 1;
`;
const priceStyles = css`
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  justify-content: flex-end;
`;
const CartFooter = _ref => {
  let {
    children,
    className,
    price,
    paymentMethodComponent,
    title,
    viewMode = '',
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    ...props,
    className: cx('etiCartFooter', footerStyles, className),
    children: [paymentMethodComponent && /*#__PURE__*/_jsx("div", {
      className: "paymentMethodComponent",
      children: paymentMethodComponent
    }), /*#__PURE__*/_jsxs("div", {
      className: titleAndPriceWrapperStyles,
      children: [title && /*#__PURE__*/_jsx("span", {
        className: titleStyles,
        "data-testid": `cartFooter-title-Title${viewMode}`,
        children: title
      }), price && /*#__PURE__*/_jsx("span", {
        className: priceStyles,
        "data-testid": `cartFooter-title-Price${viewMode}`,
        children: price
      })]
    }), children]
  });
};
export default CartFooter;
//# sourceMappingURL=CartFooter.js.map